// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3KZg3","label":"Radio_label__21Xjv","checkMark":"Radio_checkMark__2D8EN","disabled":"Radio_disabled__1kDFn"};